import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {connect} from 'react-redux'



const screenDoor: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 99,
    backgroundColor: 'rgba(22,22,22,0.5)',
    justifyContent: 'center',
    alignContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'hidden'
};

class _ScreenDoor extends React.Component<Tgcc.BaseProps, any> {
    state: { documentOverflow: null };

    componentWillMount = () => {
        if(document.body.style.overflow != 'hidden'){
            this.setState({ documentOverflow: document.body.style.overflow})
            document.body.style.overflow='hidden';
        }
    }

    componentWillUnmount = () => {
        if(this.state && this.state.documentOverflow !== null)
            document.body.style.overflow=this.state.documentOverflow;
    }

    render(){
        return(
            <div key="0" style={screenDoor}>
                {this.props.children}
            </div>
        );
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

export var ScreenDoor = connect(mapStateToProps)(_ScreenDoor);